<template lang="pug">
  div.page--contact.page
    page-header.page-header--contact(
      :breadcrumb-only="false"
      :page-title="trans('menus.frontend.navigation.contact-us')"
      header-class="page-header--help"
      header-background="/img/frontend/page/page-header-default-background.jpg"
    )
    .contact-us__navigation
      .container
        .row
          .col
            ul.list-unstyled.list-inline.mb-0.text-center
              li.list-inline-item
                a(href='#contacts', :title="trans('menus.frontend.navigation.contact-us')") {{ trans('menus.frontend.navigation.contact-us') }}
              li.list-inline-item
                a(href='#distributors', :title="trans('menus.frontend.navigation.distributors')") {{ trans('menus.frontend.navigation.distributors') }}
              li.list-inline-item
                a(href='#jobs', :title="trans('menus.frontend.navigation.join-us')") {{ trans('menus.frontend.navigation.join-us') }}
    .container#contacts
      elementor(object-type="template" object-slug="contact-us-page")
    .contact-map
      elementor(object-type="template" object-slug="contact-map")
    .container
      .row.justify-content-center
        .col-12
          .contact-box
            .row
              .col-md-7
                h4.contact-box__title {{ trans('labels.frontend.contact-us.send_message_title') }}
                p.contact-box__description
                  | {{ trans('labels.frontend.contact-us.send_message_txt') }}
                img.d-none.d-md-block(src='/img/frontend/icons/conversation.svg', alt='')
              .col-md-5
                contact-form

    .contact-partners#distributors
      .container
        .row.mb-2
          .col
            h4.contact-partners__title {{ trans('menus.frontend.navigation.distributors') }}
        .row
          .col
            distributors-slideshow
    .contact-jobs#jobs
      .container
        .row
          .col
            h4.contact-jobs__title {{ trans('menus.frontend.navigation.join-us') }}
            job-career-list


</template>

<script>
import BreadcrumbsManager from '../../mixins/BreadcrumbsManager';
import DistributorsSlideshow from '../../components/distributor/DistributorsSlideshow.vue';
import JobCareerList from '../../components/job-career/JobCareerList.vue';
import PageHeader from '../../components/layouts/PageHeader.vue';
import ContactForm from './ContactForm.vue';

export default {
  components: {
    ContactForm,
    DistributorsSlideshow,
    JobCareerList,
    PageHeader,
  },
  mixins: [BreadcrumbsManager],
  metaInfo() {
    return {
      title: Lang.get('menus.frontend.navigation.contact-us'),
    };
  },
  created() {
    this.setBreadcrumbs([
      { name: Lang.get('menus.frontend.navigation.contact-us') },
    ]);
  },
  methods: {
    onMarkerClicked() {
      window.location = 'https://www.google.com/maps/dir/?api=1&destination=13.801081,100.509271';
    },
  },
};
</script>
